import React, { useState, useCallback } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import { HorizontalLine } from "App/styles";

import { Container, Actions, CancelFormButton, SaveButtonWrapper } from "./styles";

import { WhiteLargeButton } from "basics/buttons";

export default function ItemForm({
  formFields,
  waiting,
  schema,
  item,
  onUpdateItem,
  onCreateItem,
  onCancel,
}) {
  const { register, unregister, handleSubmit, errors, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  // Campos (por id) que tienen una subida de archivo en curso. Mientras alguno
  // esté pendiente deshabilitamos Guardar: así no se persiste un adjunto sin
  // URL ni se pisa un valor a medio subir.
  const [pendingUploads, setPendingUploads] = useState({});

  const setPending = useCallback((fieldId, pending) => {
    setPendingUploads((prev) => {
      if (!!prev[fieldId] === pending) return prev;
      return { ...prev, [fieldId]: pending };
    });
  }, []);

  const uploading = Object.values(pendingUploads).some(Boolean);

  const onSubmit = (data) => {
    delete data["id"];

    if (item) {
      onUpdateItem(item.id, data);
    } else {
      onCreateItem(data);
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input
          ref={register}
          type="hidden"
          name="actived"
          id="actived"
          value={item ? item.actived : true}
        />

        {formFields(register, unregister, setValue, errors, item, setPending)}

        <HorizontalLine />

        <Actions>
          {onCancel && (
            <CancelFormButton type="button" onClick={onCancel} disabled={waiting}>
              Cancelar
            </CancelFormButton>
          )}
          <SaveButtonWrapper>
            <WhiteLargeButton type="submit" disabled={waiting || uploading}>
              {waiting
                ? "Guardando…"
                : uploading
                ? "Subiendo archivo…"
                : "Guardar"}
            </WhiteLargeButton>
          </SaveButtonWrapper>
        </Actions>
      </form>
    </Container>
  );
}
